// @ts-strict-ignore
import { Decoder, Reader, tools } from 'ts-ebml';
import { Call, CallEvents, CallRB, CallRecordingState, CallStatus, CallType } from "rainbow-web-sdk/models/call.model";
import { Subject, interval } from 'rxjs';
import { XmppService } from 'rainbow-web-sdk/services/core/xmpp.service';
import { FileStorageService } from 'rainbow-web-sdk/services/files/fileStorage.service';
import { FileServerService } from 'rainbow-web-sdk/services/files/fileServer.service';
import { ErrorHelperService } from 'rainbow-web-sdk/services/utilities/errorHelper.service';
import { Service } from 'rainbow-web-sdk/services/service';
import { Subscription } from 'rxjs';
import { Buffer } from 'buffer';
import { LoggerService} from 'rainbow-web-sdk/services/core/logger.service';
import { MainService, RBEvent, UserType } from 'rainbow-web-sdk';
import { ConversationServiceRB } from '../conversation/conversation.service';
import { ContactService } from '../core/contact.service';
import { FileDescriptor } from '../../models/common';
import { JingleSession } from '../../libs/strophe/strophe.jingle.session';
import { WebrtcP2PService } from '../webrtc/webrtcP2P.service';
import { ConversationRB } from '../../models/conversation.model';
import { format } from 'date-fns';
import { CallServiceEvents, CallServiceRB } from './call.service';
import { FileDocumentServiceRB } from '../fileDocument/fileDocument.service';

window["Buffer"] = Buffer; // A CORRIGER

// declare let MediaRecorder: any; // A CORRIGER

export const CALL_RECORDER_SVC = 'CallRecorderService';


export enum CallRecorderServiceEvents {
    /**
     * @eventProperty
     * The recording is in progress.
     */
    RECORDING_IS_IN_PROGRESS = 'recordingInProgress',

    /**
     * @eventProperty
     * The recording is available in storage.
     */
    RECORDING_IS_AVAILABLE_IN_STORAGE = 'recordingIsAvailableInStorage',

    /**
     * @eventProperty
     * The recording is saved on pc.
     */
    RECORDING_SAVED_ON_PC = "recordingSavedOnPc",
}

export interface CallRecorderInstance {

    /**
     * The id of the CallRecorderInstance.
     */
    id: string;
    /**
     *  This 'mediaRecorder' is the MediaRecorder instance used to record the call.
     *  It is created when the recording starts and used to manage the recording process.
    */
    mediaRecorder?: MediaRecorder;

    /**
     *  This 'audioContext' is the AudioContext instance used to manage audio processing.
     *  It is created when the recording starts and used to handle audio streams.
    */
    audioContext: AudioContext;

    /**
     *  This 'subscriptions' is an array of subscriptions used to manage the lifecycle of the call recorder instance.
     */
    subscriptions?: Subscription[];

    /**
     *  This 'data' is the Blob instance that contains the recorded data.
    */
    data?: Blob;

    /**
     *  This 'duration' is the duration of the recording in seconds.
    */
    duration?: number;

    /**
     *  This 'durationTimer' is a subscription that manages the duration of the recording.
    */
    durationTimer?: Subscription;

    /**
     *  This 'fileName' is the name of the file that will be created for the recording.
    */
    fileName?: string;

    /**
     *  This 'backupFileDescriptor' is the FileDescriptor instance that contains the backup file information.
    */
    backupFileDescriptor?: FileDescriptor;

    /*******************
     * DESKTOP APP ONLY
    ********************/

    /**
     *  This 'fullPathUrl' is the full path URL of the file where the recording will be saved.
     *  It is used in the desktop application to save the file locally.
    */
    fullPathUrl?: string;

    /**
     *  This 'inputPeerConnection' is the RTCPeerConnection instance used to manage the input stream of the call.
    */
    inputPeerConnection? : RTCPeerConnection;

    /**
     *  This 'ouputPeerConnection' is the RTCPeerConnection instance used to manage the output stream of the call.
    */
    ouputPeerConnection? : RTCPeerConnection;

    /**
     *
    */
    //outputVideoStream?;
}


/**
 * The CallRecorderService class contains the methods and their implementations required for recording.
*/
export class CallRecorderService extends Service {

    public callService: CallServiceRB = CallServiceRB.getInstance();
    public fileDocumentService: FileDocumentServiceRB = FileDocumentServiceRB.getInstance();
    private conversationService: ConversationServiceRB = ConversationServiceRB.getInstance();
    private xmppService: XmppService = XmppService.getInstance();
    private fileStorageService: FileStorageService = FileStorageService.getInstance();
    private fileServerService: FileServerService = FileServerService.getInstance();
    private errorHelperService: ErrorHelperService = ErrorHelperService.getInstance();
    private logger: LoggerService = LoggerService.getInstance();
    private mainService: MainService = MainService.getInstance();
    private contactService: ContactService = ContactService.getInstance();
    private webrtcP2PServce: WebrtcP2PService = WebrtcP2PService.getInstance();
    private centralizedService: any = null;
    private rxSubject: Subject<RBEvent> = new Subject<RBEvent>();
    //manage the list of the current recorders, based on the ID of the call
    private recorders: Record<string, CallRecorderInstance> = {};

    //management of empty video black track that is "common" for all sessions
    private blankVideoTrack: MediaStreamTrack;
    private blankVideoTrackInterval: NodeJS.Timeout;
    private blankVideoStream : MediaStream;
    private videoElement: HTMLVideoElement;
    private canvasElement : HTMLCanvasElement;
    // private webrtcCanvasElement;
    // private webrtcVideoElement;
    // private webrtcVideoCanvasOutputElement;


    public static getInstance() {
        return Service.create(CALL_RECORDER_SVC, CallRecorderService);
    }

    public static build() {
        return new CallRecorderService();
    }
    protected constructor() { super(); }


    public async start(): Promise<void> {
        this.centralizedService = this.mainService.inject("CentralizedService");
        this.logger.info("[CallRecorderService] === STARTED ===");
    }

    public async stop(): Promise<void> {
        this.logger.info("[CallRecorderService] === STOPPING ===");

        //check for any remaining recorders, and stop them
        Object.values(this.recorders).forEach((recorder) => {
            if (recorder) {
                this.removeRecordingInstance(recorder);
            }
        });

        this.recorders = {};

        this.logger.info("[CallRecorderService] === STOPPED ===");
    }


    public sendEvent(name: CallRecorderServiceEvents) {
        this.rxSubject.next(RBEvent.create(name));
    }

    public subscribe(handler: any): Subscription { return this.rxSubject.subscribe(handler); }


    /**
     *  This API allows the user to start e recording of the current call.
     * @param callToRecord - The call to record
     */
    public async startRecording(callToRecord: Call) {
        const call: CallRB = callToRecord as CallRB;
        try {
            this.logger.info(`[CallRecorderService] startRecording for call ${call.id}`);
            let options = {};
            let stream;
            let videoStream;
            let audioStream;
            const tracks: MediaStreamTrack[] = [];
            const isSafari = (window.adapter.browserDetails.browser === "safari");
            const isFirefox = (window.adapter.browserDetails.browser === "firefox");

            //create new instance for the record
            const recorderInstance: CallRecorderInstance = {
                id: call.id,
                mediaRecorder: undefined,
                audioContext: new AudioContext()
            };

            recorderInstance.data = new Blob([], { type: "video/webm" });
            recorderInstance.fileName = "conv_" + call.contact?.displayName + "_" + format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS") + ".webm";

            let session: JingleSession;
            if (call.callType === CallType.PHONE) {
                //find the related webrtc session to the phone call
                session = this.xmppService.connection.jingle.sessions[call.mediaPillarCall?.webrtcCallRef?.id];
            }
            else {
                session = this.xmppService.connection.jingle.sessions[call.id];
            }

            if (!session) {
                throw new Error("Missing session");
            }

            //should we add video to the recording
            let addVideo = false;
            let secondSession;
            let secondCall;

            //we need to add video in case of webtc call, or if there already exists webrtc sharing on top of pbx;
            //otherwise not
            if (!isSafari) {
                if (call.callType === CallType.PHONE) {
                //find if there's webrtc call on top of current PBX call
                    secondCall = this.webrtcP2PServce.getSecondSharingCallForPbxCall(call);
                    if (secondCall) {
                        addVideo = true;
                        secondSession = this.xmppService.connection.jingle.sessions[secondCall.id];
                    }
                }

                if (call.callType === CallType.WEBRTC) {
                    addVideo = true;
                }
            }

            //build local peer connection
            await this.buildLocalPeerConnection(recorderInstance, session, addVideo, secondSession);

            //local audio stream
            tracks.push(recorderInstance.ouputPeerConnection.getReceivers()[0].track);
            //remote audio stream
            tracks.push(session.remoteStreamsObject["0"].getAudioTracks()[0]);

            if (isSafari) {
                audioStream = new MediaStream();
                tracks.forEach((track) => { audioStream.addTrack(track); });
            }
            else {
                const sources: MediaStreamAudioSourceNode[] = tracks.map((track) => recorderInstance.audioContext.createMediaStreamSource(new MediaStream([track])));
                const dest = recorderInstance.audioContext.createMediaStreamDestination();
                sources.forEach((source) => source.connect(dest));
                audioStream = dest.stream;
            }

            if (addVideo && recorderInstance.ouputPeerConnection.getReceivers()[1]?.track) {
            //send the track to draw on the canvas and get constant FPS output stream
                videoStream = new MediaStream();
                // recorderInstance.outputVideoStream = await this.drawWebrtcStreamOnCanvas(recorderInstance.ouputPeerConnection.getReceivers()[1]?.track);
                // videoStream = recorderInstance.outputVideoStream;
                videoStream.addTrack(recorderInstance.ouputPeerConnection.getReceivers()[1].track);
            // videoStream.addTrack(recorderInstance.outputVideoStream);
            }

            //build stream to send to the recorder
            if (audioStream && videoStream) {
                stream = new MediaStream([
                    ...audioStream.getTracks(),
                    ...videoStream.getTracks(),
                ]);
            } else {
                stream = audioStream;
            }

            //NOTE:
            //FOR VP8 it's best to use webm format
            //for H264 it's better to use MP4; This probably should be done based on the codec preference for the user / session;
            //for PBX calls with PCMA / PCMU (G.711) we should use WAV format for the file
            //for the moment we leave as default webm format;
            recorderInstance.data = new Blob([], { type: "video/webm" });
            recorderInstance.fileName = "conv_" + call.contact?.displayName + "_" + format(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS") + ".webm";

            if (isSafari || isFirefox) {
                options = {};
            }
            else if (addVideo) {
                if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8")) {
                    options = { mimeType: "video/webm\; codecs=vp8" };
                } else if (MediaRecorder.isTypeSupported("video/webm;codecs=h264")) {
                    options = { mimeType: "video/webm\; codecs=h264" };
                } else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9")) {
                    options = { mimeType: "video/webm\; codecs=vp9" };
                } else if (MediaRecorder.isTypeSupported("video/mpeg")) {
                    options = { mimeType: "video/mpeg" };
                }
            }
            else {
                if (MediaRecorder.isTypeSupported("audio/webm")) {
                    options = { mimeType: "audio/webm" };
                    recorderInstance.data = new Blob([], { type: "audio/webm" });
                }
            }

            if (isSafari) {
                recorderInstance.mediaRecorder = new MediaRecorder(stream);
                recorderInstance.mediaRecorder.addEventListener('dataavailable', (error) => {
                    this.onCreateFileFromBlobForSafari(error.data, recorderInstance);
                });
            } else {
                recorderInstance.mediaRecorder = new MediaRecorder(stream, options);
                recorderInstance.mediaRecorder.ondataavailable = (event) => {
                    this.onDataAvailable(event, recorderInstance);
                    return true;
                };
                recorderInstance.mediaRecorder.onstop = () => {
                    this.onStop(recorderInstance);
                };
            }

            recorderInstance.mediaRecorder.onerror = this.onError.bind(this);

            recorderInstance.mediaRecorder.start();

            call.recorder.state = CallRecordingState.RECORDING_IN_PROGRESS;
            //save the instance in the list of recorders
            this.recorders[call.id] = recorderInstance;

            this.conversationService.updateCallCapabilities(call);

            call.sendEvent(CallEvents.ON_CALL_RECORDING_UPDATE, {recorderState: CallRecordingState.RECORDING_IN_PROGRESS});

            //start the duration timer
            recorderInstance.duration = 0;
            recorderInstance.durationTimer = interval(1000).subscribe(() => {
                recorderInstance.duration++;
            });

            this.addListenersForCall(call, secondCall);

            //get the related conversation for the call
            if (call.contact?.userType === UserType.USER) {
                //if in call with RB User, send recording message
                const conversation = await this.conversationService.getConversation(call.contact) as ConversationRB;
                this.conversationService.sendRecordingMessage(conversation, "start");
            }
            else {
                this.webrtcP2PServce.playStartRecordSoundInCall();
            }

            this.logger.info(`[CallRecorderService] startRecording for call ${call.id} -- success`);
        }
        catch (error) {
            this.logger.info(`[CallRecorderService] startRecording for call ${call.id} -- error ${error}`);
        }
    }

    /**
     * This method builds the local peer connection for the call recording.
     * @param recorderInstance - The CallRecorderInstance containing the recording data.
     * @param session - The JingleSession for the call.
     * @param addVideo - Whether to add video to the recording.
     * @param secondSession - The second JingleSession for the call, if applicable.
     */
    private async buildLocalPeerConnection(recorderInstance: CallRecorderInstance, session: JingleSession, addVideo: boolean, secondSession?: JingleSession) {

        recorderInstance.inputPeerConnection = new RTCPeerConnection(null);
        recorderInstance.inputPeerConnection.onicecandidate = event => recorderInstance.ouputPeerConnection.addIceCandidate(event.candidate);

        recorderInstance.inputPeerConnection.ontrack = event => console.log(event.streams[0]);

        //  ---------------------------------------------------------------------------------------
        //  Create output RTC peer connection
        //  ---------------------------------------------------------------------------------------
        recorderInstance.ouputPeerConnection = new RTCPeerConnection(null);
        recorderInstance.ouputPeerConnection.onicecandidate = event => recorderInstance.inputPeerConnection.addIceCandidate(event.candidate);

        recorderInstance.ouputPeerConnection.ontrack = event => { };

        //  ---------------------------------------------------------------------------------------
        //  Get video source
        //  ---------------------------------------------------------------------------------------

        //  Add stream to input peer
        recorderInstance.inputPeerConnection.addTrack(session.localTransceivers[0].sender.track);

        if (addVideo) {
            //find the right video track to add, if existing; otherwise create black video
            const track = await this.getOrCreateVideoTrack(session, secondSession);

            if (track) {
                recorderInstance.inputPeerConnection.addTrack(track);
            }
        }

        //  ---------------------------------------------------------------------------------------
        //  Make RTC call
        //  ---------------------------------------------------------------------------------------

        const offer = await recorderInstance.inputPeerConnection.createOffer();
        await recorderInstance.inputPeerConnection.setLocalDescription(offer);
        await recorderInstance.ouputPeerConnection.setRemoteDescription(offer);

        const answer = await recorderInstance.ouputPeerConnection.createAnswer();
        await recorderInstance.ouputPeerConnection.setLocalDescription(answer);
        await recorderInstance.inputPeerConnection.setRemoteDescription(answer);
    }


    /**
     * This API allows the user to stop the recording of the current call.
     * @param callToRecord - The call to record
     */
    public async stopRecording(callToRecord: Call) {
        const call: CallRB = callToRecord as CallRB;
        this.logger.info(`[CallRecorderService] stopRecording for call ${call.id}`);
        try {
            if (this.recorders[call.id]?.mediaRecorder) {
                this.recorders[call.id].mediaRecorder.stop();
                this.recorders[call.id].durationTimer.unsubscribe();
                this.closeAudioContext(this.recorders[call.id].audioContext);
            }
        }
        catch (error) {
            this.logger.error(`Error while stopping the recording : ${error}`);
        }

        call.recorder.state = CallRecordingState.RECORDING_STOPPED;

        this.conversationService.updateCallCapabilities(call);

        call.sendEvent(CallEvents.ON_CALL_RECORDING_UPDATE, {recorderState: CallRecordingState.RECORDING_STOPPED});

        if (call.contact?.userType === UserType.USER) {
            //if in call with RB User, send recording message
            const conversation = await this.conversationService.getConversation(call.contact) as ConversationRB;
            if (conversation) this.conversationService.sendRecordingMessage(conversation, "stop");
        }
    }

    /**
     *  This API allows the user to pause the recording of the current call.
     * @param callToRecord - The call to record
     */
    public pauseRecording(callToRecord: Call) {
        const call: CallRB = callToRecord as CallRB;
        this.logger.info(`[CallRecorderService] pauseRecording for call ${call.id}`);
        if (this.recorders[call.id]?.mediaRecorder) {
            if (call.recorder.state === CallRecordingState.RECORDING_IN_PROGRESS) {
                this.recorders[call.id].mediaRecorder.pause();
                call.recorder.state = CallRecordingState.RECORDING_PAUSED;

                if (this.recorders[call.id].durationTimer) {
                    this.recorders[call.id].durationTimer.unsubscribe();
                    this.recorders[call.id].durationTimer = null;
                }
            }
        }

        this.conversationService.updateCallCapabilities(call);
        call.sendEvent(CallEvents.ON_CALL_RECORDING_UPDATE, {recorderState: CallRecordingState.RECORDING_PAUSED});
    }


    /**
     * This API allows the user to resume the recording of the current call.
     * @param callToRecord - The call to record
     */
    public resumeRecording(callToRecord: Call) {
        const call: CallRB = callToRecord as CallRB;
        this.logger.info(`[CallRecorderService] resumeRecording for call ${call.id}`);
        if (this.recorders[call.id]?.mediaRecorder) {
            if (call.recorder.state === CallRecordingState.RECORDING_PAUSED) {
                this.recorders[call.id].mediaRecorder.resume();
                call.recorder.state = CallRecordingState.RECORDING_IN_PROGRESS;

                if (!this.recorders[call.id].durationTimer) {
                    this.recorders[call.id].durationTimer = interval(1000).subscribe(() => {
                        this.recorders[call.id].duration++;
                    });
                }
            }
        }

        this.conversationService.updateCallCapabilities(call);
        call.sendEvent(CallEvents.ON_CALL_RECORDING_UPDATE, {recorderState: CallRecordingState.RECORDING_IN_PROGRESS});
    }


    /**
     * This API allows the user to cancel the recording.
     * It means that you can stop a recording without saving the recording file.
     * @param callToRecord - The call to record
     */
    public cancelRecording(callToRecord: Call) {
        const call: CallRB = callToRecord as CallRB;
        this.logger.info(`[CallRecorderService] stopRecording for call ${call.id}`);
        try {
            if (this.recorders[call.id]?.mediaRecorder) {
                this.recorders[call.id].mediaRecorder.stop();
                this.recorders[call.id].durationTimer.unsubscribe();
                this.closeAudioContext(this.recorders[call.id].audioContext);

                call.recorder.state = CallRecordingState.RECORDING_STOPPED;
                this.conversationService.updateCallCapabilities(call);
                call.sendEvent(CallEvents.ON_CALL_RECORDING_UPDATE, {callRecorderState: CallRecordingState.RECORDING_STOPPED});

                this.recorders[call.id].mediaRecorder.onstop = () => {

                };
            }
        }
        catch (error) {
            //in case something goes wrong with the STOP, we need to clear all data to avoid memory leak
            this.logger.error("Error : ", error);
        }
    }

    /**
     * This API allows the user to get the recording duration.
     * @param callToRecord - The call that will be recorded.
     */
    public getRecordingDuration(callToRecord : Call) : number {
        const call: CallRB = callToRecord as CallRB;
        return this.recorders[call.id] ? this.recorders[call.id].duration : 0;
    }


    /**
     * This method adds listeners for the call events.
     * @param call - The call for which to add listeners.
     * @param secondCall - The second call for which to add listeners, if applicable.
     */
    private addListenersForCall(call: CallRB, secondCall?: CallRB) {
        this.recorders[call.id].subscriptions = [];
        this.recorders[call.id].subscriptions.push(call.subscribe(async (event: RBEvent) => {
            try {
                if (event?.name === CallEvents.ON_CALL_STATUS_CHANGE) {
                    //manage call status change
                    if (call.callStatus === CallStatus.HOLD || call.callStatus === CallStatus.PUT_ON_HOLD) {
                        //pause the current recording
                        this.pauseRecording(call);
                    }
                    if (call.callStatus === CallStatus.ACTIVE) {
                        this.resumeRecording(call);
                    }
                    if (call.callStatus === CallStatus.RELEASING || call.callStatus === CallStatus.ENDED) {
                        this.stopRecording(call);
                    }
                }
                if (event?.name === CallEvents.ON_CALL_MEDIA_UPDATED) {
                    //the local audio has changed
                    this.logger.info(`[CallRecorderService] ON_CALL_MEDIA_UPDATED -- for call  ${call.id}`);
                    this.recorders[call.id].inputPeerConnection.getSenders()[0].replaceTrack(call.localStreams[0].getAudioTracks()[0]);

                    //check for video change
                    setTimeout(async () => {
                        if (this.recorders[call.id].inputPeerConnection.getSenders()[1]) {
                            const session = this.xmppService.connection.jingle.sessions[call.id];
                            const track = await this.getOrCreateVideoTrack(session);
                            if (track) {
                                this.logger.info(`[CallRecorderService] ON_CALL_MEDIA_UPDATED -- for call  ${call.id} -- update video track`);
                                this.recorders[call.id].inputPeerConnection.getSenders()[1].replaceTrack(track);
                            }
                        }
                    }, 500);
                }
            }
            catch {
                //do nothing
            }
        }));

        //manage update on the WEBRTC Sharing call on top of PBX
        if (secondCall) {
            this.recorders[call.id].subscriptions.push(secondCall.subscribe(async (event: RBEvent) => {
                try {
                    if (event?.name === CallEvents.ON_CALL_STATUS_CHANGE) {

                        if (secondCall.callStatus === CallStatus.RELEASING || secondCall.callStatus === CallStatus.ENDED) {
                            //replace the current recording with black video

                            if (this.recorders[call.id].inputPeerConnection.getSenders()[1]) {
                                let track;
                                if (this.blankVideoTrack) { track = this.blankVideoTrack; }
                                else {
                                    await this.createBlackTrack();
                                    track = this.blankVideoTrack;
                                }

                                if (track) {
                                    this.logger.info(`[CallRecorderService] webrtc call on top of PBX call ${call.id} is now ended, replace track`);
                                    this.recorders[call.id].inputPeerConnection.getSenders()[1].replaceTrack(track);
                                }
                            }
                        }
                    }
                }
                catch {
                    //do nothing
                }
            }));
        }
    }

    /**
     * This method creates a black video track for the call recording.
     * @param blob - The Blob to convert to a file.
     * @param recorderInstance - The CallRecorderInstance containing the recording data.
     */
    private onCreateFileFromBlobForSafari(blob: any, recorderInstance: CallRecorderInstance) {
        this.logger.info('[CallRecorderService] onCreateFileFromBlobForSafari -- Size of blob : ' + blob.size);
        recorderInstance.data = blob;
        recorderInstance.fileName = recorderInstance.fileName.replace("mp4", "wav");

        this.createFinalFileForRecording(recorderInstance);
    }


    /**
     * This method retrieves or creates a video track for the call recording.
     * @param session - The JingleSession for the call.
     * @param secondSession - The second JingleSession for the call, if applicable.
     */
    private async getOrCreateVideoTrack(session: JingleSession, secondSession?: JingleSession): Promise<MediaStreamTrack> {
        let track: MediaStreamTrack;
        //priority: local sharing / remote sharing / remote video / local video / (webrtc call on top of PBX) sharing / empty video
        if (session.localTransceivers[2]?.sender?.track && (session.localTransceivers[2]?.currentDirection === "sendrecv" || session.localTransceivers[2]?.currentDirection === "sendonly")) { track = session.localTransceivers[2].sender.track; }
        else if (session.localTransceivers[2]?.receiver?.track?.enabled && (session.localTransceivers[2]?.currentDirection === "sendrecv" || session.localTransceivers[2]?.currentDirection === "recvonly")) { track = session.localTransceivers[2].receiver.track; }
        else if (session.localTransceivers[1]?.receiver?.track?.enabled && (session.localTransceivers[1]?.currentDirection === "sendrecv" || session.localTransceivers[1]?.currentDirection === "recvonly")) { track = session.localTransceivers[1].receiver.track; }
        else if (session.localTransceivers[1]?.sender?.track && (session.localTransceivers[1]?.currentDirection === "sendrecv" || session.localTransceivers[1]?.currentDirection === "sendonly")) { track = session.localTransceivers[1].sender.track; }
        else if (secondSession?.localTransceivers[2]?.sender?.track && (secondSession?.localTransceivers[2]?.currentDirection === "sendrecv" || secondSession?.localTransceivers[2]?.currentDirection === "sendonly")) { track = secondSession.localTransceivers[2].sender.track; }
        else if (secondSession?.localTransceivers[2]?.receiver?.track && (secondSession?.localTransceivers[2]?.currentDirection === "sendrecv" || secondSession?.localTransceivers[2]?.currentDirection === "recvonly")) { track = secondSession.localTransceivers[2].receiver.track; }
        else if (this.blankVideoTrack) { track = this.blankVideoTrack; }
        else {
            await this.createBlackTrack();
            track = this.blankVideoTrack;
        }

        return track;
    }

    // private async drawWebrtcStreamOnCanvas(track: MediaStreamTrack): Promise<MediaStreamTrack> {
    //     const stream = new MediaStream([track]);
    //     if (!this.webrtcCanvasElement) { this.webrtcCanvasElement = document.createElement("canvas"); }
    //     const ctx = this.webrtcCanvasElement.getContext("2d");

    //     if (!this.webrtcVideoElement) { this.webrtcVideoElement = document.createElement("video"); }
    //     this.webrtcVideoElement.muted = true;
    //     this.webrtcVideoElement.srcObject = stream;

    //     // this.webrtcVideoElement.width = 720;
    //     // this.webrtcVideoElement.height = 1280;
    //     // this.webrtcVideoElement.style.objectFit = "fill";

    //     await this.webrtcVideoElement.play();

    //     // this.webrtcCanvasElement.width = this.webrtcVideoElement.width;
    //     // this.webrtcCanvasElement.height = this.webrtcVideoElement.height;

    //     // Call the draw function every 30ms (for ~33fps)
    //     // const drawFrame = () => {
    //     //     ctx.drawImage(this.webrtcVideoElement, 0, 0);
    //     //     requestAnimationFrame(drawFrame); // Repeat the process
    //     // };
    //     // drawFrame(); // Start drawing the video frames to the canvas

    //     this.blankVideoTrackInterval = setInterval(() => ctx.drawImage(this.webrtcVideoElement, 0, 0), 10);

    //     // document.body.appendChild(this.webrtcVideoElement);
    //     // document.body.appendChild(this.webrtcCanvasElement);

    //     // const drawFrame = () => {
    //     //     this.webrtcCanvasElement.width = this.webrtcVideoElement.width;
    //     //     this.webrtcCanvasElement.height = this.webrtcVideoElement.height;
    //     //     ctx.drawImage(this.webrtcVideoElement, 0, 0);
    //     //     requestAnimationFrame(drawFrame); // Repeat the process
    //     // };
    //     // drawFrame(); // Start drawing the video frames to the canvas

    //     if (!this.webrtcVideoCanvasOutputElement) { this.webrtcVideoCanvasOutputElement = document.createElement("video"); }
    //     this.webrtcVideoCanvasOutputElement.muted = true;
    //     this.webrtcVideoCanvasOutputElement.srcObject = this.webrtcCanvasElement.captureStream(25);
    //     // await this.webrtcVideoCanvasOutputElement.play();
    //     console.error(this.webrtcVideoCanvasOutputElement.srcObject);
    //     return (this.webrtcVideoCanvasOutputElement.captureStream) ? this.webrtcVideoCanvasOutputElement.captureStream().getVideoTracks()[0] : this.webrtcVideoCanvasOutputElement.mozCaptureStream().getVideoTracks()[0];
    // }


    /**
     * This method creates a black video track for the call recording.
     */
    private async createBlackTrack(): Promise<void> {
        try {
            //create black video
            if (!this.canvasElement) { this.canvasElement = document.createElement("canvas"); }
            const ctx = this.canvasElement.getContext("2d");
            this.blankVideoTrackInterval = setInterval(() => ctx.clearRect(0, 0, 1, 1), 500);
            ctx.clearRect(0, 0, 1, 1);
            this.blankVideoStream = this.canvasElement.captureStream(25);

            if (!this.videoElement) { this.videoElement = document.createElement("video"); }
            this.videoElement.muted = true;
            this.videoElement.srcObject = this.blankVideoStream;
            await this.videoElement.play();
            const videoElementAny = this.videoElement as HTMLVideoElement & { captureStream?: () => MediaStream; mozCaptureStream?: () => MediaStream };
            this.blankVideoTrack = (videoElementAny.captureStream) ?
                videoElementAny.captureStream().getVideoTracks()[0] :
                videoElementAny.mozCaptureStream().getVideoTracks()[0];
        }
        catch (error) {
            this.logger.error(`[CallRecorderService] createBlackTrack error ${error}`);
        }
    }


    /**
     * This method uploads the file to the server.
     * @param recordingInstance - The CallRecorderInstance containing the recording data.
     * @param backup - Whether to upload as a backup file or not.
     */
    public async uploadFileToServer(recordingInstance: CallRecorderInstance, backup: boolean = false): Promise<any> {
        try {
            const file = { name: recordingInstance.fileName, size: recordingInstance.data?.size } as File;

            if (file.size === 0) {
                this.logger.error("[CallRecorderService] uploadFileToServer error - empty file");
                throw new Error("[CallRecorderService] uploadFileToServer -- Empty file pb");
            }

            try {
                const fileDescriptor = await this.fileStorageService.createFileDescriptor(file);
                await this.fileServerService.uploadAFileByChunk(fileDescriptor, recordingInstance.data as File);
                this.logger.info(`[CallRecorderService] uploadFileToServer (backup: ${backup}) success`);
                return fileDescriptor;
            } catch (errorUpload) {
                const errorInfo = await this.errorHelperService.getErrorInfo(errorUpload, "uploadFileToServer");
                this.logger.error(`[CallRecorderService] uploadFileToServer -- Unexpected error while creating file descriptor/uploading file -- ${errorUpload}`);
                throw errorInfo.error;
            }
        } catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, "uploadFileToServer");
            this.logger.error(`[CallRecorderService] uploadFileToServer -- Unexpected error -- ${error}`);
            throw errorInfo.error;
        }
    }

    /**
     * This method either handles the error event from the MediaRecorder or fill the data attrbute from recorderInstance with Blob.
     * @param event - The data available event from the MediaRecorder.
     * @param recorderInstance - The CallRecorderInstance containing the recording data.
    */
    public async onDataAvailable(event: any, recorderInstance: CallRecorderInstance) : Promise<void> {
        this.logger.info("[CallRecorderService] onDataAvailable: size = " + event.data.size);

        try {
            if (event.data.size > 0) {
                let chunk = event.data;

                recorderInstance.data = new Blob([recorderInstance.data, chunk], { type: chunk.type });
                chunk = null;
            }
        } catch (error) {
            this.logger.error(`[CallRecorderService] onDataAvailable -- Unexpected error -- ${error}`);
            throw error;
        }

    }

    /**
     * This method handles the error event from the MediaRecorder or manage the file by uploading it on the server or writing it to disk.
     * @param recordingInstance - The CallRecorderInstance containing the recording data.
     */
    private async onStop(recordingInstance: CallRecorderInstance) {
        // Open-point : why is the video forced in mp4 ?
        // this.recordBuffer = new Blob(this.data, { type: "video/webm" });
        //for firefox
        //add some timeout in order to receive the data

        setTimeout(async () => {
            if (recordingInstance.data && recordingInstance.data.size > 10000000) {
                this.sendEvent(CallRecorderServiceEvents.RECORDING_IS_IN_PROGRESS);
            }

            this.logger.info(`[CallRecorderService] On stop recording for ${recordingInstance.id}`);

            try {
                //try to create backup-file
                if (this.contactService.userContact.fileStorageEnabled) {
                    //upload the file in the local storage just in case
                    recordingInstance.backupFileDescriptor = await this.uploadFileToServer(recordingInstance, true);
                    this.logger.info(`[CallRecorderService] backup for ${recordingInstance.id} created`);
                }
                else {
                    //try to write file temp file to local PC
                    await this.writeFileToDisk(recordingInstance, true);
                }
            }
            catch (error) {
                this.logger.warn(`[CallRecorderService] backup for ${recordingInstance.id} was not created ${error}`);
            }

            try {
                recordingInstance.data = await this.injectMetadata(recordingInstance.data);
                this.createFinalFileForRecording(recordingInstance);
            }
            catch (_err) {
                this.logger.warn(`[CallRecorderService] injectMetadata error ${_err} -- create raw data file`);
                this.createFinalFileForRecording(recordingInstance);
            }
        }, 1000);
    }


    /**
     * This method handles the error event from the MediaRecorder.
     * @param recorderInstance - The CallRecorderInstance containing the recording data.
     * @param isTempFile - Whether the file is a temporary file or not.
     */

    private async writeFileToDisk(recorderInstance: CallRecorderInstance, isTempFile: boolean = false): Promise<void> {
        //manage desktop app with write stream
        if (this.centralizedService?.fileSystem && this.centralizedService?.fileSystem?.createWriteStream && this.centralizedService?.fileSystem?.unlink) {
            this.logger.info(`[CallRecorderService] writeFileToDisk ${recorderInstance.id} (backup: ${isTempFile})`);
            recorderInstance.fullPathUrl = this.centralizedService.fileSaver.getFolderPath() + '/' + recorderInstance.fileName;

            const writeStream = await this.centralizedService.fileSystem.createWriteStream(recorderInstance.fullPathUrl + (isTempFile ? '.temp' : ''));

            const array = await recorderInstance.data.arrayBuffer();
            const chunkBuffer = Buffer.from(array);

            return new Promise((resolve, reject) => {
                writeStream.write(chunkBuffer, async (err) => {
                    if (err) {
                        this.logger.info(`[CallRecorderService] writeFileToDisk ${recorderInstance.id} -- (backup: ${isTempFile}) fail ${err}`);
                        writeStream.end();
                        reject();
                        return;
                    }

                    this.logger.info(`[CallRecorderService] writeFileToDisk ${recorderInstance.id} (backup: ${isTempFile}) -- success`);
                    writeStream.end();

                    //remove temp file
                    if (!isTempFile) {
                        this.centralizedService.fileSystem?.unlink(recorderInstance.fullPathUrl + '.temp');
                    }

                    resolve();
                });
            });
        }
    }

    /**
     * This method creates the final file for the recording.
     * @param recordingInstance - The CallRecorderInstance containing the recording data.
     */
    private async createFinalFileForRecording(recordingInstance: CallRecorderInstance) {
        this.logger.info(`[CallRecorderService] createFinalFileForRecording for ${recordingInstance.id} -- with size ${recordingInstance.data?.size}`);

        try {
            if (this.contactService.userContact.fileStorageEnabled) {
                await this.uploadFileToServer(recordingInstance);

                //delete the backup file if any
                if (recordingInstance.backupFileDescriptor) {
                    this.fileStorageService.deleteFileDescriptor(recordingInstance.backupFileDescriptor.id);
                }

                //file is available in the cloud storage
                this.sendEvent(CallRecorderServiceEvents.RECORDING_IS_AVAILABLE_IN_STORAGE);
            }
            else {
                if (this.centralizedService?.fileSystem?.createWriteStream) {
                    await this.writeFileToDisk(recordingInstance);

                    //file is available on the PC of the user
                    this.sendEvent(CallRecorderServiceEvents.RECORDING_SAVED_ON_PC);
                }
                //send event to download file manually
                else if (this.centralizedService?.fileSaver) {
                    this.centralizedService.fileSaver.fileDownload(recordingInstance.data, null, null, recordingInstance.fileName, true);
                    const file = { name: recordingInstance.fileName, size: recordingInstance.data?.size } as File;
                    const fileDescriptor = await this.fileStorageService.createFileDescriptor(file);
                    //send event to download file manually
                    this.callService.sendEvent(CallServiceEvents.ON_CALL_RECORDER_FILE_DESCRIPTOR_READY, fileDescriptor);
                }
                else {
                    //SDK case, send event to download blob data
                    this.callService.sendEvent(CallServiceEvents.ON_CALL_FILE_RECORDER_READY, recordingInstance.data);
                }
            }
        }
        catch (error) {
            this.logger.info(`[CallRecorderService] createFinalFileForRecording for ${recordingInstance.id} -- error ${error}. Propose to save it locally`);
            //try to save file manually or send event for SDK
            if (this.centralizedService?.fileSaver) {
                this.sendEvent(CallRecorderServiceEvents.RECORDING_SAVED_ON_PC);
                this.centralizedService.fileSaver.fileDownload(recordingInstance.data, null, null, recordingInstance.fileName, true);
                const file = { name: recordingInstance.fileName, size: recordingInstance.data?.size } as File;
                const fileDescriptor = await this.fileStorageService.createFileDescriptor(file);
                //send event to download file manually
                this.callService.sendEvent(CallServiceEvents.ON_CALL_FILE_RECORDER_READY, {blobData: recordingInstance.data, fileDescriptor: fileDescriptor});
            }
            else {
                //SDK case, send event to download blob data
                const file = { name: recordingInstance.fileName, size: recordingInstance.data?.size } as File;
                const fileDescriptor = await this.fileStorageService.createFileDescriptor(file);
                this.callService.sendEvent(CallServiceEvents.ON_CALL_FILE_RECORDER_READY, {blobData: recordingInstance.data, fileDescriptor: fileDescriptor});
            }
        }
        this.callService.sendEvent(CallServiceEvents.ON_CALL_FILE_RECORDER_READY);
        this.removeRecordingInstance(recordingInstance);
    }


    /**
     * This method removes the recording instance from the list of recorders.
     * @param recorderInstance - The CallRecorderInstance to remove.
     */
    private removeRecordingInstance(recorderInstance: CallRecorderInstance) {
        this.logger.info(`[CallRecorderService] removeRecordingInstance ${recorderInstance.id}`);
        recorderInstance.data = null;
        recorderInstance.mediaRecorder = null;

        if (recorderInstance.durationTimer) {
            recorderInstance.durationTimer.unsubscribe();
            recorderInstance.durationTimer = null;
            recorderInstance.duration = 0;
        }

        if (recorderInstance.subscriptions?.length) {
            recorderInstance.subscriptions.forEach((subscription) => subscription.unsubscribe());
            recorderInstance.subscriptions = [];
        }

        if (recorderInstance.inputPeerConnection) {
            recorderInstance.inputPeerConnection.close();
        }

        if (recorderInstance.ouputPeerConnection) { recorderInstance.ouputPeerConnection.close(); }

        delete this.recorders[recorderInstance.id];

        //check if we need to remove the canvas black stream
        if (!Object.keys(this.recorders).length) {
            //destroy the blank video
            if (this.blankVideoTrackInterval) { clearInterval(this.blankVideoTrackInterval); this.blankVideoTrackInterval = undefined; }
            if (this.blankVideoTrack) { this.blankVideoTrack.stop(); this.blankVideoTrack = undefined; }
            if (this.blankVideoStream) { this.blankVideoStream = undefined; }
            if (this.videoElement) { this.videoElement?.pause(); this.videoElement.srcObject = null; }
        }
    }

    /**
     * This method injects metadata into the Blob.
     * @param blob - The Blob to inject metadata into.
     */
    private async injectMetadata(blob: Blob) : Promise<Blob> {
        if (window.adapter.browserDetails.browser === "firefox") {
            return blob;
        }

        this.logger.info(`[CallRecorderService] injectMetadata`);
        const decoder = new Decoder();
        const reader = new Reader();
        const readstream = blob.stream() as any;
        const readerBlob = readstream.getReader();
        // const type = blob.type;
        let type = blob.type;
        if (type.indexOf(";") !== -1) { type = type.slice(0, type.indexOf(";")); }

        while (true) {
            let { done, value } = await readerBlob.read();
            if (done) {
                reader.stop();
                break;
            }
            let elms = decoder.decode(value);
            // As browser upgrade webm meta attributes are gradually added,
            // so filter unknown type to bypass this issue.
            elms = elms?.filter((elm: any) => elm.type !== 'unknown');
            elms.forEach(elm => {
                reader.read(elm);
            });
            value = null;
        }

        const refinedMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, reader.duration, reader.cues);
        const refinedMetadataBlob = new Blob([refinedMetadataBuf], { type: type });
        const firstPartBlobWithoutMetadata = blob.slice(reader.metadataSize);
        blob = undefined;
        const finalBlob = new Blob([refinedMetadataBlob, firstPartBlobWithoutMetadata], { type: type });

        this.logger.info(`[CallRecorderService] injectMetadata -- success`);
        return finalBlob;
    }

    /**
     * This method closes the AudioContext.
     * @param audioContext - The AudioContext to close.
     */
    private closeAudioContext(audioContext: AudioContext) : void {
        if (audioContext) {
            if (audioContext.destination) {
                audioContext.destination.disconnect();
            }
            if (audioContext.state !== "closed") {
                audioContext.close();
            }
        }
    }

    /**
     * This method handles the error event from the MediaRecorder.
     * @param event - The error event from the MediaRecorder.
     */
    private onError(event: any) : void {
        this.logger.error(`[CallRecorderService] onError : ${event?.message} ${event?.name}`);
    }
}
